module.exports = __webpack_public_path__ + "img/zwiebelrostbraten.c7b7c9c3.png";